<script>
  /**
   * @type {number} width of the progress bar
   */
  export let width
  /**
   * @type {string} content to be shown along with the progress
   */
  export let content
</script>

<div class="mt-12 flex w-full flex-col items-center justify-center gap-12 text-base font-bold text-[#ff6a00] mobile:w-4/5 mobile:text-lg lg:w-3/5">
  <div class="flex w-full flex-col items-center gap-3 mobile:gap-6">
    <!-- <h1 class="text-2xl font-bold text-black dark:text-white lg:text-3xl">{Math.round(width)} %</h1> -->
    <h1 class="text-2xl font-bold text-black dark:text-white lg:text-3xl">{width.toFixed(2)} %</h1>
    <div class="progress w-full bg-[#dfdfdf] dark:bg-lightgray">
      <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: {width}%" />
    </div>
    <h1 class="text-lg font-semibold tracking-widest text-[#ff6a00]">{content} ...</h1>
  </div>
</div>

<style lang="postcss">
  .progress {
    display: -ms-flexbox;
    display: flex;
    height: 1.25rem;
    overflow: hidden;
    font-size: 0.75rem;
    /* background-color: #dfdfdf; */
    border-radius: 0.25rem;
  }

  .progress-bar-striped {
    background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
    background-size: 1rem 1rem;
  }

  .progress-bar-animated {
    -webkit-animation: progress-bar-stripes 1s linear infinite;
    animation: progress-bar-stripes 1s linear infinite;
  }

  @keyframes progress-bar-stripes {
    0% {
      background-position: 1rem 0;
    }
    100% {
      background-position: 0 0;
    }
  }

  .progress-bar {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    background-color: #ff6a00;
    transition: width 0.6s ease;
  }
</style>
